enum PaymentType {
    CASH = "CASH",
    DEBIT = "DEBIT",
    DEBIT_DISTANCE = "DEBIT_DISTANCE",
    CREDIT = "CREDIT",
    CREDIT_DISTANCE = "CREDIT_DISTANCE",
    ZELLE = "ZELLE",
    ZELLE_LOWER = "ZELLE_LOWER",
    ZELLE_EXTRA = "ZELLE_EXTRA",
    ZELLE_ARTICLE_HIGH = "ZELLE_ARTICLE_HIGH",
    CHECK = "CHECK",
    WIRE_TRANSFER = "WIRE_TRANSFER",
    DISTANCE = "DISTANCE",
    DISTANCE_LOWER = "DISTANCE_LOWER",
}

export default PaymentType;